import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'identityDocumentSingleFile',
    'identityDocumentRectoFile',
    'identityDocumentVersoFile',
  ]

  identityDocumentSingleFileChanged() {
    if (this.identityDocumentSingleFileTarget.files.length > 0) {
      this.clearFile(this.identityDocumentRectoFileTarget)
      this.clearFile(this.identityDocumentVersoFileTarget)
    }
  }

  identityDocumentRectoFileChanged() {
    if (this.identityDocumentRectoFileTarget.files.length > 0) {
      this.clearFile(this.identityDocumentSingleFileTarget)
    }
  }

  identityDocumentVersoFileChanged() {
    if (this.identityDocumentVersoFileTarget.files.length > 0) {
      this.clearFile(this.identityDocumentSingleFileTarget)
    }
  }

  clearFile(input) {
    input.value = ''

    const event = new CustomEvent('document-input:clear', { bubbles: true })
    input.dispatchEvent(event)
  }
}
